<template>
  <div>
    <div v-if="!readonly" class="cfs-field d-flex flex-column" :class="{ 'static-bg': staticBg }">
      <p class="input-title px-1 pb-1" :class="{ disabled }">
        {{ label }}
      </p>

      <vue-tel-input
        class="cfs-vue-tel-input"
        :value="value"
        :class="[!isValid && 'outline--red']"
        :input-options="{ showDialCode: true }"
        :auto-default-country="false"
        @input="onInputTel"
      />
    </div>
    <CfsReadonlyField v-else v-bind="$props" />
  </div>
</template>

<script lang="ts">
import { defineAsyncComponent, defineComponent, ref } from 'vue';

export default defineComponent({
  name: 'CfsTelephoneInput',
  components: {
    CfsReadonlyField: defineAsyncComponent(
      () => import('@/framework/inputs/special/CfsReadonlyFieldComponent.vue')
    ),
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    staticBg: {
      type: Boolean,
      default: true,
    },
    value: {
      type: String,
      default: '',
    },
  },
  setup(_, { emit }) {
    const isValid = ref(true);

    const onInputTel = (number: string, options: any) => {
      isValid.value = options.valid;
      emit('input', { number: options.formatted, options });
    };

    return { isValid, onInputTel };
  },
});
</script>
